/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FormatInputs */

const en_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const fr_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const de_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const it_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const ru_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат`)
};

const es_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const zh_cn2_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`格式`)
};

const ja_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`形式`)
};

const hi_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारूप`)
};

const pt_pt2_format = /** @type {(inputs: FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatar`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const format = /** @type {((inputs?: FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_format(inputs)
	if (locale === "de") return de_format(inputs)
	if (locale === "it") return it_format(inputs)
	if (locale === "ru") return ru_format(inputs)
	if (locale === "es") return es_format(inputs)
	if (locale === "zh-CN") return zh_cn2_format(inputs)
	if (locale === "ja") return ja_format(inputs)
	if (locale === "hi") return hi_format(inputs)
	if (locale === "pt-PT") return pt_pt2_format(inputs)
	return en_format(inputs)
});